import React from 'react';
import ReactDOM from 'react-dom/client';
import GlobalStyle from './GlobalStyle';
import App from './App';
import i18n from './i18n';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme';
import { HelmetProvider } from './lib/helmetCompat';

const root = ReactDOM.createRoot(document.getElementById('root'));

const startApp = () => {
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <App />
        </ThemeProvider>
      </HelmetProvider>
    </React.StrictMode>
  );
};

const preloadNamespaces = () => i18n.loadNamespaces(['common', 'navbar']);

if (i18n.isInitialized) {
  preloadNamespaces().then(startApp);
} else {
  i18n.on('initialized', () => {
    preloadNamespaces().then(startApp);
  });
}

reportWebVitals();
